module.exports = __webpack_public_path__ + "img/play-02.676c65b5.jpg";